import { isWebview } from '@zillow/mortgage-webview-query-params';
import { buildUrlQueryParams } from './api';
import { getConfigs } from './configs';

export const getDownPaymentAssistanceUrl = () => {
    const { zillowBaseUrl } = getConfigs();
    return `${zillowBaseUrl}/down-payment-assistance?source=Z_HomeLoans_Landing&utm_source=zillow&utm_medium=referral&utm_campaign=zhl_homeloanslp_calculator_component_main`;
};

// only available in prod
export const getCreditScoreArticleUrl = () =>
    'https://www.zillow.com/mortgage-learning/credit-score-higher/?source=Z_HomeLoans_Landing&utm_source=zillow&utm_medium=referral&utm_campaign=zhl_homeloanslp_calculator_component_main';

export const getPayOffDebtsGuideUrl = () =>
    'https://www.zillow.com/home-buying-guide/pay-off-debt/?source=Z_HomeLoans_Landing&utm_source=zillow&utm_medium=referral&utm_campaign=zhl_homeloanslp_calculator_component_main';

export const getZGMICustomQuoteUrl = outputs => {
    const { zillowBaseUrl } = getConfigs();
    const underWebview = isWebview();
    const path = underWebview ? '/mortgage/webviews/ZCQ.htm' : '/mortgage-rates/';
    const query = {
        source: 'Z_HomeLoans_Landing',
        utm_source: 'zillow',
        utm_medium: 'referral',
        utm_campaign: 'zhl_homeloanslp_calculator_component_main',
        loanType: 'purchase',
        propertyValue: Math.floor(outputs?.homePrice),
        location: outputs?.inputFields?.zipCode,
        creditScore: outputs?.inputFields?.creditScore,
        downPayment: Math.floor(outputs?.inputFields?.downPayment),
    };

    if (underWebview) {
        query.zfullscreen = true;
    }

    return `${zillowBaseUrl}${path}?${buildUrlQueryParams(query)}`;
};

export const getPrequalUrl = outputs => {
    const { zhlBaseUrl } = getConfigs();
    const underWebview = isWebview();

    const query = {
        source: 'Zillow',
        channel: 'Home_Loans',
        utm_source: 'zillow',
        utm_medium: 'referral',
        utm_campaign: 'zhl_homeloanslp_calculator_component_main',
        propertyValue: Math.floor(outputs?.homePrice),
        cityOrZip: outputs?.inputFields?.cityOrZip,
        creditScore: outputs?.inputFields?.creditScore,
        downPayment: Math.floor(outputs?.inputFields?.downPayment),
    };

    if (underWebview) {
        query.zfullscreen = true;
    }

    return `${zhlBaseUrl}/pre-qualify/?${buildUrlQueryParams(query)}`;
};

export const getFindHomeUrl = () => {
    const { zillowBaseUrl } = getConfigs();
    const query = {
        source: 'Z_HomeLoans_Landing',
        channel: 'Home_Loans',
        utm_source: 'zillow',
        utm_medium: 'referral',
        utm_campaign: 'zhl_homeloanslp_calculator_component_secondary',
    };

    return `${zillowBaseUrl}/homes/?${buildUrlQueryParams(query)}`;
};
